<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start"><ion-button (click)="megse()">Mégse</ion-button></ion-buttons>
    <ion-title>{{ cim }}</ion-title>
    <ion-buttons slot="end">
      <ion-button [strong]="true" (click)="mentes()" [disabled]="fut">
        {{ fut ? 'Mentés…' : 'Mentés' }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <p class="jv-tanulo"><b>{{ tanuloNev }}</b><br><small>{{ oktazon }}</small></p>

  <ion-input label="{{ muvelet === 'kiiratkozas' ? 'Jogviszony utolsó napja' : 'Beiratkozás napja' }}"
             label-placement="stacked" fill="outline" type="date" [(ngModel)]="datum"></ion-input>

  <ion-select *ngIf="muvelet === 'beiratkozas'" label="Osztály" label-placement="stacked"
              fill="outline" interface="popover" [(ngModel)]="osztaly">
    <ion-select-option *ngFor="let o of osztalyok" [value]="o.id">{{ o.osztaly }}</ion-select-option>
  </ion-select>

  <!-- Kiiratkozásnál a megszűnés oka (Nkt. 53. §) és az új intézmény – a beírási napló 95. § (9) ag) rovatához. -->
  <ng-container *ngIf="muvelet === 'kiiratkozas'">
    <ion-select label="A megszűnés oka" label-placement="stacked" fill="outline" interface="popover" [(ngModel)]="okKod">
      <ion-select-option [value]="''">— nincs megadva —</ion-select-option>
      <ion-select-option *ngFor="let o of okok" [value]="o.kod">{{ o.nev }}{{ o.jogalap ? ' (' + o.jogalap + ')' : '' }}</ion-select-option>
    </ion-select>
    <ion-input label="Kiegészítés (nem kötelező)" label-placement="stacked" fill="outline" maxlength="200" [(ngModel)]="ok"></ion-input>
    <ion-input label="Az új intézmény neve" label-placement="stacked" fill="outline" maxlength="255"
               placeholder="ahová felvették / átvették (OM-azonosító)" [(ngModel)]="atvevo"></ion-input>
    <ion-note color="warning" class="jv-sugo" *ngIf="iskolavaltas">
      Iskolaváltás: az új iskolának át kell adni a tanuló előrehaladási adatait és az évközi jegyeit (Nkt. 41. § (8a)) –
      az átadó csomag az Admin › Iskolaváltás képernyőn készül.
    </ion-note>
  </ng-container>

  <ion-textarea label="Záradék szövege" label-placement="stacked" fill="outline" rows="3"
                [autoGrow]="true" [(ngModel)]="szoveg"
                placeholder="Ez a szöveg kerül a törzslapra"></ion-textarea>
  <ion-note color="medium" class="jv-sugo">
    A záradék kötelező: a jogviszony változása a törzslapon ezzel jelenik meg.
  </ion-note>

  <div class="jv-sablonok" *ngIf="sablonok.length">
    <div class="cim">Sablonok (kattints a beszúráshoz)</div>
    <ion-chip *ngFor="let s of sablonok" outline (click)="sablonValaszt(s.szoveg)">
      <ion-label><b *ngIf="s.melleklet_kod">{{ s.melleklet_kod }}</b> {{ s.szoveg }}</ion-label>
    </ion-chip>
  </div>
</ion-content>
